// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container1 {
  /*width: 500px;
  height: 300px;*/
  /* background-color: cyan;*/
  display: flex;
  justify-content: flex-end;
}

.item {
  width: 100px;
  height: 100px;
  background-color: green;
  display: inline-block;
  margin: 2px;
}

.activo-label {
  margin-left: 10px;
}

.separator {
  border-top: 1px solid #dee2e6;
  /*border-bottom: 1px solid #dee2e6;*/
  margin-top: 10px;
  margin-bottom: 10px;
}

.form-check-label {
  padding-left: 5px;
}

/* Basic styling to contain the label */
.input-container {
  position: relative;
}

/* Base input styling (Bootstrap handles most of this) */
.form-control {
  transition: box-shadow 0.3s ease-in-out; /* Add transition for smoothness */
}

/* Custom glow effect on focus */
.form-control:focus {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25),
    0 0 15px rgba(13, 110, 253, 0.5); /* Glowing effect */
  border-color: #0d6efd;
}

.form-control.active {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25),
    0 0 15px rgba(13, 110, 253, 0.5); /* Glowing effect */
  border-color: #0d6efd;
}

/*
*/
@keyframes pulse-glow {
  0%,
  100% {
    /*transform: scale(1);*/
    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0.7);
  }
  50% {
    /*  transform: scale(1.05);*/
    box-shadow: 0 0 0 10px rgba(52, 152, 219, 0);
  }
}

.pulse-glow {
  animation: pulse-glow 1.5s alternate; /* inifinite */
  position: relative;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Asociados/createAsociados.css"],"names":[],"mappings":"AAAA;EACE;iBACe;EACf,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;AACpB;;AAEA,wDAAwD;AACxD;EACE,uCAAuC,EAAE,kCAAkC;AAC7E;;AAEA,gCAAgC;AAChC;EACE;oCACkC,EAAE,mBAAmB;EACvD,qBAAqB;AACvB;;AAEA;EACE;oCACkC,EAAE,mBAAmB;EACvD,qBAAqB;AACvB;;AAEA;CACC;AACD;EACE;;IAEE,uBAAuB;IACvB,2CAA2C;EAC7C;EACA;IACE,4BAA4B;IAC5B,4CAA4C;EAC9C;AACF;;AAEA;EACE,oCAAoC,EAAE,cAAc;EACpD,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".container1 {\n  /*width: 500px;\n  height: 300px;*/\n  /* background-color: cyan;*/\n  display: flex;\n  justify-content: flex-end;\n}\n\n.item {\n  width: 100px;\n  height: 100px;\n  background-color: green;\n  display: inline-block;\n  margin: 2px;\n}\n\n.activo-label {\n  margin-left: 10px;\n}\n\n.separator {\n  border-top: 1px solid #dee2e6;\n  /*border-bottom: 1px solid #dee2e6;*/\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.form-check-label {\n  padding-left: 5px;\n}\n\n/* Basic styling to contain the label */\n.input-container {\n  position: relative;\n}\n\n/* Base input styling (Bootstrap handles most of this) */\n.form-control {\n  transition: box-shadow 0.3s ease-in-out; /* Add transition for smoothness */\n}\n\n/* Custom glow effect on focus */\n.form-control:focus {\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25),\n    0 0 15px rgba(13, 110, 253, 0.5); /* Glowing effect */\n  border-color: #0d6efd;\n}\n\n.form-control.active {\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25),\n    0 0 15px rgba(13, 110, 253, 0.5); /* Glowing effect */\n  border-color: #0d6efd;\n}\n\n/*\n*/\n@keyframes pulse-glow {\n  0%,\n  100% {\n    /*transform: scale(1);*/\n    box-shadow: 0 0 0 0 rgba(52, 152, 219, 0.7);\n  }\n  50% {\n    /*  transform: scale(1.05);*/\n    box-shadow: 0 0 0 10px rgba(52, 152, 219, 0);\n  }\n}\n\n.pulse-glow {\n  animation: pulse-glow 1.5s alternate; /* inifinite */\n  position: relative;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
